export const GOOGLE_CHROME_DOWNLOAD_URL = 'https://www.google.com/intl/fr_fr/chrome/';
export const MICROSOFT_EDGE_DOWNLOAD_URL = 'https://www.microsoft.com/fr-fr/edge';
export const MOZILLA_FIREFOX_DOWNLOAD_URL = 'https://www.mozilla.org/fr/firefox/new/';
